// Fail fast handler to catch typos quickly.
export const safetyHandler = (objectName) => ({
  get: (obj, prop) => {
    if (prop in obj) {
      return obj[prop];
    }
    const errorMessage = `Invalid Reference: The key '${prop}' does not exist in ${objectName}.`;
    // eslint-disable-next-line no-console
    console.error(errorMessage);
    throw new Error(errorMessage);
  },
});
